import { COPILOT_THREAD_ID } from '../../constants/superstoreStorageKeys';
import { deleteSuperstoreValue, getSuperStoreValue, setSuperstoreValue } from '../../utils/superStoreUtils';
export const getCopilotThreadIdFromSuperstore = async () => {
  const copilotThreadId = await getSuperStoreValue(COPILOT_THREAD_ID);
  return copilotThreadId || null;
};
export const setCopilotThreadIdInSuperstore = async threadId => {
  await setSuperstoreValue(COPILOT_THREAD_ID, threadId);
};
export const deleteCopilotThreadIdFromSuperstore = async () => {
  await deleteSuperstoreValue(COPILOT_THREAD_ID);
};